var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("div", { staticClass: "chart-page" }, [
        _c("div", { staticClass: "card mb-2" }, [
          _c(
            "div",
            {
              staticClass: "card-body",
              staticStyle: { "text-align": "-webkit-center" },
            },
            [
              _c("div", { staticClass: "chart-title mb-4" }, [
                _vm._v("黑名單報表"),
              ]),
              _c("apexchart", {
                attrs: {
                  width: "500",
                  height: "350",
                  type: "bar",
                  options: _vm.chartOptions,
                  series: _vm.chartSeries,
                },
              }),
              _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "mr-2", attrs: { for: "" } }, [
                      _vm._v("年份"),
                    ]),
                    _c("ValidationProvider", {
                      attrs: { required: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ errors }) {
                            return [
                              _c("el-date-picker", {
                                staticClass: "w-50",
                                attrs: {
                                  type: "year",
                                  clearable: false,
                                  "picker-options": _vm.pickerOptions,
                                },
                                model: {
                                  value: _vm.year,
                                  callback: function ($$v) {
                                    _vm.year = $$v
                                  },
                                  expression: "year",
                                },
                              }),
                              errors[0]
                                ? _c("span", { staticClass: "text-danger" }, [
                                    _vm._v(" " + _vm._s(errors[0]) + " "),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "card search-card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("ValidationObserver", {
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit }) {
                    return [
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("月份"),
                              ]),
                              _c("ValidationProvider", {
                                attrs: { required: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("el-date-picker", {
                                            staticClass: "w-100",
                                            attrs: {
                                              type: "monthrange",
                                              clearable: false,
                                              "picker-options":
                                                _vm.pickerOptions,
                                            },
                                            model: {
                                              value: _vm.monthRange,
                                              callback: function ($$v) {
                                                _vm.monthRange = $$v
                                              },
                                              expression: "monthRange",
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              staticStyle: {
                                "margin-top": "30px",
                                "margin-left": "10px",
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.tableInfo.page = 1
                                  _vm.getBlacklistDetail()
                                },
                              },
                            },
                            [_vm._v(" 查詢 ")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info",
                              staticStyle: {
                                "margin-top": "30px",
                                "margin-left": "10px",
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return handleSubmit(_vm.exportBlacklist)
                                },
                              },
                            },
                            [_vm._v(" 匯出報表 ")]
                          ),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "yahome-table-wrap" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "姓名" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.showDetailModal(props.row)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(props.row.Name) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "IdNo", label: "身分證字號/護照號碼" },
              }),
              _c("el-table-column", {
                attrs: { prop: "Reason", label: "原因" },
              }),
              _c("el-table-column", {
                attrs: { prop: "CreateUser", label: "標記者" },
              }),
              _c("el-table-column", {
                attrs: { label: "標記時間" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$common.dateFormatter(props.row.CreateTime)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "el-popconfirm",
                          {
                            attrs: {
                              title: "確認刪除？",
                              "confirm-button-text": "確認",
                              "cancel-button-text": "取消",
                            },
                            on: {
                              confirm: function ($event) {
                                return _vm.blacklistRemoval(props.row.ResumeId)
                              },
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  slot: "reference",
                                  type: "danger",
                                  size: "mini",
                                },
                                slot: "reference",
                              },
                              [_vm._v(" 刪除 ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "prev, pager, next",
              total: _vm.totalData,
              "page-size": 10,
              "current-page": _vm.tableInfo.page,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.tableInfo, "page", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.tableInfo, "page", $event)
              },
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated bounceInLeft",
            "leave-active-class": "animated bounceOutRight",
          },
        },
        [
          _vm.isShowDetail
            ? _c("div", { staticClass: "detail-modal" }, [
                _c("div", { staticClass: "detail-modal-inner" }, [
                  _c("div", { staticClass: "menu" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            ;(_vm.detailCurrentPage = 0),
                              (_vm.ResumeType = "IDL")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("eva-icon", {
                              attrs: { name: "person-outline", fill: "#FFF" },
                            }),
                            _vm._v(" IDL 履歷 "),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            ;(_vm.detailCurrentPage = 0),
                              (_vm.ResumeType = "DL")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("eva-icon", {
                              attrs: { name: "person-outline", fill: "#FFF" },
                            }),
                            _vm._v(" DL 履歷 "),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "close-show-detail",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.isShowDetail = !_vm.isShowDetail
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: {
                            name: "close-circle",
                            fill: "#FFF",
                            width: "50",
                            height: "50",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "page-wrap" },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 0
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c("div", { staticClass: "title" }, [
                                      _c(
                                        "div",
                                        { staticClass: "item text-center" },
                                        [_vm._v("履歷")]
                                      ),
                                    ]),
                                    _vm.ResumeType === "IDL"
                                      ? _c("IdlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.ResumeType === "DL"
                                      ? _c("DlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }